<template>
    <b-modal ref="modal" size="lg" id="modal-observation" hide-footer title="Inserir observação">
        <ValidationObserver v-slot="{ handleSubmit }" slim ref="observer">
            <form action="#" method="post" @submit.prevent="handleSubmit(onSubmit)">
                <b-row>
                    <b-col>
                        <ValidationProvider name="observação" :rules="{ required: product.observacao.obrigatorio }" slim v-slot="{ errors, classes, required}">
                            <div class="form-group">
                                <label :for="'obs' + uid" class="observation__description">
                                    {{ product.observacao.descricao }} {{ product.observacao.obrigatorio ? '*' : '' }}
                                </label>
                                <textarea class="form-control" :id="'obs' + uid" v-model.trim="texto" maxlength="500" name="observation" cols="10" rows="5"></textarea>
                                <small v-show="errors[0]" class="text-danger text-left">{{ errors[0] }}</small>
                                <small class="d-block">
                                    Máximo de 500 caracteres ({{ 500 - texto.length }} restantes)
                                </small>
                            </div>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <div class="observation__rule">
                            <div v-if="error_msg" class="error-alert" v-html="error_msg"></div>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="d-flex justify-content-end mt-2">
                            <button type="submit" class="btn-default btn-square pr-5 pl-5" :disabled="sending">
                                {{ sending ? 'Enviando' : 'Salvar' }}
                            </button>
                        </div>
                    </b-col>
                </b-row>
            </form>
        </ValidationObserver>
    </b-modal>
</template>

<script>
    import {ValidationProvider, ValidationObserver} from "vee-validate";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        props: {
            product: {
                type: Object,
                default: () => ({
                    id: '',
                    observacao: {
                        descricao: '',
                        texto: '',
                        obrigatorio: false
                    }
                })
            }
        },
        data: function () {
            return {
                texto: '',
                sending: false,
                error_msg: ''
            }
        },
        mounted() {
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
                if (modalId === 'modal-observation') {
                    if (typeof this.product === 'object' && typeof this.product.observacao === 'object') {
                        this.texto = this.product.observacao.texto
                    }
                }
            })
        },
        computed: {
            uid() {
                return this._uid
            }
        },
        methods: {
            async onSubmit() {
                let params = new FormData();
                params.append('product_order_id', this.product.id);
                params.append('note', this.texto);
                this.sending = true;
                this.$axios.$post('?p=ecommerce_pedidos_api_v1&metodo=note', params)
                    .then((response) => {
                        if (response.msg === 'sucesso') {
                            // this.product.observacao.texto = this.texto
                            this.$root.$emit('updatedCart')
                            this.$refs['modal'].hide()
                            this.$store.dispatch('order/loadOrder')
                            // $('#modal-observation').modal('hide');
                        } else {
                            this.error_msg = response.msg_completa
                        }
                        this.sending = false;
                    })
                    .catch((e) => {
                        console.log(e)
                        this.error_msg = 'Não foi possível enviar!'
                        this.sending = false;
                    })
            }
        }
    };
</script>
